export class relatorio {
    public id: string | null;
    public codigo: number | undefined;
    public etapa: number | undefined;
    public proximaEtapa: number | undefined;
    public nome: string;
    public descricao: string;
    public icone: string;
    public consulta: string;
    public colecao: string;
    public textoAjudaHTML:string="";
    constructor(id: string | null = null,
      codigo: number | undefined = undefined,
      etapa: number | undefined = undefined,
      proximaEtapa: number | undefined = undefined,
      nome: string = "",
      descricao: string = "",
      icone: string = "",
      consulta: string = "",
      colecao: string = "",
      textoAjudaHTML:string="") {
      this.id = id;
      this.etapa = etapa;
      this.codigo = codigo;
      this.descricao = descricao;
      this.proximaEtapa = proximaEtapa;
      this.nome = nome;
      this.icone = icone;
      this.consulta = consulta;
      this.colecao = colecao;
      this.textoAjudaHTML = textoAjudaHTML;
    }
}